<template>
  <div>
    <div class="hero">
      <div class="img-bg">
        <img :src="require('@/assets/svg/hero-myapp-deargod.svg')" alt="Dear God Background" />
      </div>
      <div class="overlay-text">
        <div>
          <h2 class="text-center"
              style="color: white; font-size: 4em;"
          >
            <i>DearGod</i>
          </h2>
          <h5
              class="d-none d-md-inline"
              style="margin-top: 25px;"
           >
            Welcome to "DearGod," a comforting haven where the synergy of advanced AI technology and the eternal
            wisdom of the King James Bible provides solace and guidance. Here, find a nurturing embrace for your deepest feelings and a guiding light
            for your journey. Join us in this gentle exploration, where the harmonious blend of technology and scripture offers a comforting hand to guide you towards inner peace
            and spiritual fulfillment.
          </h5>
        </div>
        <div
            class="overlay-bar"
        >
          <div
              style="background-color: white;
          border-color: black;
          padding: 5px;
          border-radius: 15px;
          margin-left: 35%;
          margin-right: 35%;
          box-shadow: 5px 5px 5px 5px whitesmoke;"
          >
            <div
                class="text-center d-none d-md-block"
                style="background-color: #cbeefd; border-radius: 15px; padding:20px;">
              <h4>
                  Write Your Letter Now!
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
import Player from "@/components/common/player";
export default {
  name: "guide-hero-banner",
  data() {
    return {
      v2: false,
      video: {
        videoId: "530298833",
        thumbnail: require("@/assets/svg/video.svg"),
        text: "Title Video",
        id: "232"
      },
      moreVideos: [
        {
          id: "1334",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        },
        {
          id: "133234",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        },
        {
          id: "1332344",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        },
        {
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        }
      ],
      fetching: false,
      bankModal: "bank-modal",
      heroBannerVideo: "hero-banner-video-tutorial",
      connectedAccount: {},
      incompeleteBoarding: false,
      playing: false
    };
  },
  components: {
    Player
  },
  beforeMount() {
    this.fetching = true;
  },
  mounted() {
    this.getAccount();
  },
  computed: {
    ...mapGetters({
      profile: "user/profile",
      user: "user/user"
    })
  },
  methods: {
    getAccount() {
      this.$store
        .dispatch("stripe/getConnectedAccount", this.user.uid)
        .then(res => {
          if (res) {
            this.retrieveAccount(res.account_id);
          } else {
            this.fetching = false;
          }
        })
        .catch(e => {
          this.fetching = false;
        });
    },
    retrieveAccount(account_id) {
      let func = firebase.functions().httpsCallable("retrieveConnectedAccount");
      func({
        account_id: account_id
      })
        .then(res => {
          this.connectedAccount = Object.assign(
            {},
            res.data.external_accounts.data[0]
          );
          if (!res.data.details_submitted) {
            this.incompeleteBoarding = true;
          }
          this.fetching = false;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  margin-bottom: 24px;
  .overlay-bar {
    z-index: 2;
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -40px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: end;
  }
  .overlay-text {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 50px;
    h1 {
      font-size: 24px;
      line-height: 33px;
      color: #474d52;
      font-weight: bold;
    }
    p {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
    }
    .btn-round-outline {
      svg {
        margin-right: 6px;
      }
    }
  }
  .img-bg {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: auto;
      min-height: 170px;
      object-fit: cover;
    }
  }
}
</style>
